import Axios from 'axios';
import Properties from '../config/properties';
/*eslint-disable */
export default () => {
    return Axios.create({
        baseURL: Properties.urlBase
    })
}